<template>
	<div class="item">
		<router-link
			class="item-container"
			:to="{name: 'single', params: {catId: catId, id: item.id}}"
		>
			<div
				class="image"
				:style="{width, height, maxWidth: width, maxHeight: height}"
			>
				<mockup :item="item" :thumb="true"></mockup>
			</div>
			<div class="title">{{ item.company }} {{ item.title }}</div>
		</router-link>

		<a
			class="style"
			@mouseover="styleDropdown = true"
			@mouseleave="styleDropdown = false"
			v-if="item.styles.length > 1"
		>
			{{ style.title }}
			<template>
				<span class="style-icon" v-html="icon('chevron')"></span>

				<transition name="styles">
					<div class="styles" v-if="styleDropdown">
						<div class="styles-wrap">
							<a
								class="styles-style"
								v-for="style in item.styles"
								:key="style.title"
								@click="styleSet(style)"
								>{{ style.title }}</a
							>
						</div>
					</div>
				</transition>
			</template>
		</a>

		<div
			class="colors"
			v-if="style.colors.length > 1"
			:class="{side: item.colorSide}"
		>
			<a
				class="color"
				v-for="color in style.colors"
				:key="color.title"
				:title="color.title"
				:class="{active: color.active}"
				:style="{backgroundColor: color.hex}"
				@click="colorSet(color)"
			>
			</a>
		</div>
	</div>
</template>

<script>
import mockup from "./mockup.vue";

export default {
	components: {mockup},
	props: {
		item: {type: Object, required: true},
		catId: {type: String, required: true},
		height: {type: String, required: true},
		width: {type: String, required: true},
	},
	data() {
		return {
			styleDropdown: false,
		};
	},
	computed: {
		style: (t) => t.item.styles.find((x) => x.active),
	},
	methods: {
		styleSet(style) {
			this.item.styles.forEach((x) => (x.active = false));
			style.active = true;
			this.styleDropdown = false;
		},
		colorSet(color) {
			this.style.colors.forEach((x) => (x.active = false));
			color.active = true;
		},
	},
};
</script>

<style lang="scss" scoped>
.item {
	position: relative;
	margin: 1em 2em;
	margin-left: 0;
	padding: 0 0.2em;

	@include res {
		font-size: 0.9em;
	}

	@include mobile {
		margin: 1em;
	}

	&-container {
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
		align-items: center;
		padding: 2em 2.5em 3.8em;
		position: relative;
		background-color: $white1;
		box-shadow: 0 0px 5px lighten(black, 80%);
		text-align: center;
		user-select: none;
		// border: 1px solid $greylight2;
		// border-radius: 4px;
		background-color: #ffffff;
		background-image: $itemBack;

		@include res {
			font-size: 0.9em;
			padding-top: 2.5em;
		}
	}
}

.style {
	position: absolute;
	top: 0.5em;
	left: 0.75em;
	padding: 0.2em 0.4em;
	font-size: 0.7em;
	text-transform: uppercase;
	font-weight: 500;
	user-select: none;
	display: flex;
	align-items: center;
	border: 1px solid $greylight3;
	border-radius: 2px;
	color: $grey1;

	@include res {
		font-size: 0.75em;
	}

	&-icon {
		display: inline-flex;
		margin-left: 0.1em;

		::v-deep svg {
			$s: 1em;
			width: $s;
			height: $s;
			transform: rotate(-90deg);
			margin-right: -2px;
			path {
				fill: $grey1;
			}
		}
	}

	.styles {
		position: absolute;
		top: 0;
		left: -1px;
		padding-top: 2.25em;
		text-align: left;

		&-style {
			display: block;
			padding: 0.3em 0.4em;
			color: $color2;
			background-color: $white1;
		}

		&-wrap {
			position: relative;
			margin-top: 0.25em;
			border: 1px solid $color2;
			border-radius: 2px;

			&:after,
			&:before {
				bottom: 100%;
				left: 25%;
				border: solid transparent;
				content: " ";
				height: 0;
				width: 0;
				position: absolute;
				pointer-events: none;
			}

			&:after {
				border-color: rgba(0, 0, 0, 0);
				border-bottom-color: $color2;
				border-width: 7px;
				margin-left: -7px;
			}
			&:before {
				border-color: rgba(122, 61, 245, 0);
				border-bottom-color: transparent;
				border-width: 8px;
				margin-left: -8px;
			}
		}
	}
}

.colors {
	position: absolute;
	bottom: 0.5em;
	right: 0.75em;
	display: flex;

	&.side {
		flex-direction: column;
		margin-bottom: 3.5em;
		.color {
			$s: 13px;
			width: $s;
			height: $s;
		}
	}

	.color {
		position: relative;
		$s: 15px;
		width: $s;
		height: $s;
		border-radius: 50%;
		margin-left: 0.4em;
		margin-top: 0.4em;
		border: 1px solid $grey1;

		@include res {
			$s: 14px;
			width: $s;
			height: $s;
		}
		&.active {
			border-color: $black1;
			// &:after {
			// 	content: "";
			// 	position: absolute;
			// 	top: calc(100% + 3px);
			// 	left: 0;
			// 	right: 0;
			// 	margin: auto;
			// 	$s: 0.2em;
			// 	width: 1px;
			// 	height: $s;
			// 	background-color: $color1;
			// }
		}
	}
}

.image {
	position: relative;
	display: flex;
	justify-content: center;
	align-items: flex-end;
}

.title {
	font-size: 0.95em;
	font-weight: 500;
	text-align: center;
	position: absolute;
	bottom: 1.6em;
	left: 0;
	right: 0;
}

.styles-enter-active,
.styles-leave-active {
	transition:
		transform 0.1s ease,
		opacity 0.1s ease;
}
.styles-enter,
.styles-leave-to {
	transform: translateY(-5px);
	opacity: 0;
}
</style>
